
<fa-icon
  data-tooltip-position="top"
  [attr.data-tooltip-text]="'base.readonly_description' | transloco"
  [icon]="['far', 'pencil-slash']"
  size="sm"
  class="ml-1 text-muted">
</fa-icon>
